import { render, staticRenderFns } from "./ProductZoomer.vue?vue&type=template&id=b1cfe0f4&scoped=true"
import script from "./ProductZoomer.vue?vue&type=script&lang=js"
export * from "./ProductZoomer.vue?vue&type=script&lang=js"
import style0 from "./ProductZoomer.vue?vue&type=style&index=0&id=b1cfe0f4&prod&lang=css"
import style1 from "./ProductZoomer.vue?vue&type=style&index=1&id=b1cfe0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cfe0f4",
  null
  
)

export default component.exports